<template>
    <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <div class="col-md-7">
                    <button
                        type="button"
                        @click="showBody(0)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 0 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Lista
                    </button>
                    <button
                        type="button"
                        @click="showCreate(1)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 1 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Agregar
                    </button>
                    <button
                        type="button"
                        @click="showBody(3)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 3 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Ordenar
                    </button>
                    <button
                        type="button"
                        @click="showBody(4)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 4 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Banner
                    </button>
                    <button
                        type="button"
                        @click="showBody(5)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 5 ? 'active' : '',
                        ]"
                    >
                        &nbsp;SEO
                    </button>
                </div>
                <div class="col-md-5 text-right align-top text-success">
                    <span style="font-size: 20px">Preguntas Frecuentes</span>
                </div>
            </div>

            <contest-faq-list-component
                v-if="page == 0"
                v-bind:model_id="model_id"
                @change="callChangeList"
            ></contest-faq-list-component>
            <contest-faq-form-component
                v-if="page == 1"
                v-bind:parent_id="model_id"
                v-bind:model_id="contest_faq_id"
                @change="callChangeCreate"
                :key="componentKey"
            ></contest-faq-form-component>
            <contest-faq-form-component
                v-if="page == 2"
                v-bind:parent_id="model_id"
                v-bind:model_id="contest_faq_id"
            ></contest-faq-form-component>
            <contest-faq-order-component
                v-if="page == 3"
                v-bind:model_id="model_id"
            ></contest-faq-order-component>
            <contest-faq-section-component
                v-if="page == 4"
                v-bind:model_id="model_id"
            ></contest-faq-section-component>
            <seo-component
                v-if="page == 5"
                v-bind:url="'/api/seo/faqs'"
                v-bind:parent_id="model_id"
            ></seo-component>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
            contest_faq_id: 0,
            componentKey: 0,
        };
    },
    methods: {
        showCreate() {
            this.contest_faq_id = 0;
            this.page = 1;
            this.componentKey += 1;
        },
        showBody(vallue) {
            this.page = vallue;
            this.contest_faq_id = 0;
        },
        callChangeList(id) {
            this.contest_faq_id = id;
            this.page = 2;
        },
        callChangeCreate() {
            this.page = 0;
        },
    },
    mounted() {},
};
</script>
